export default __webpack_public_path__ + "static/media/icono-youtube.58c84e58.svg";